export default __webpack_public_path__ + "static/media/sigeoplogo.80ec8a2a.png";